import { useMemo } from "react";
import UniFormMed from "../../../med/UniFormMed";
import UniFieldSUI from "../../../../xAppLib/UniForm/UniField-SUI";

const ConsentQuestions = props => {

	const { categories , prefilledConsent} = props;
	const prettyArrayString = arr => {
		const beginning = arr.slice(0, -1).join(", ");
		const end = arr.slice(-1)[0] ?? "the outlined treatment";
		return arr.length > 1 ? `${beginning} & ${end}` : end;
	};

	// Might be better to use med questions for this instead of hardcoding fields.
	// But for now, this will do.
	const FIELDS = useMemo(
		() => [
			{
				name: "general_consent",
				type: "checkbox",
				label: "I have read and understood the information below and am aware of the risks and complications associated with treatment.",
				options: [{ c: "yes", n: "Yes" }],
				value :  prefilledConsent["general_consent"]
			},
			{
				name: "treatment_consent",
				type: "checkbox",
				label: `I consent to undergo ${prettyArrayString(categories)}. I have had a face-to-face consultation with my healthcare practitioner, where I had the opportunity to ask questions and address any concerns.`,
				options: [{ c: "yes", n: "Yes" }],
				value : prefilledConsent["treatment_consent"]
			},
			{
				name: "photo_consent",
				type: "checkbox",
				label: "I consent to photographs being taken before and after this treatment and understand that these photographs will form part of my medical record and will be used in accordance with the InstantCosmetics Privacy Policy. A copy of the Privacy Policy is available upon request.",
				options: [{ c: "yes", n: "Yes" }],
				value : prefilledConsent["photo_consent"]
			},
			{
				name: "financial_consent",
				type: "checkbox",
				label: "I have read and understood the financial agreement and consent to the payment terms outlined, including the fees, cancellation policy, and any additional charges that may apply.",
				options: [{ c: "yes", n: "Yes" }],
				value : prefilledConsent["financial_consent"]
			},
			{
				name: "cost_consent",
				type: "checkbox",
				label: "I understand that this procedure is elective, not covered by Medicare, and I have been informed of the costs involved, including charges for any revisions, additional treatments and top-ups.",
				options: [{ c: "yes", n: "Yes" }],
				value : prefilledConsent["cost_consent"]
			},
		],
		[categories, prefilledConsent],
	);

	return (
		<UniFormMed {...props} section="consent_questions" fields={FIELDS}>
			{(values, valids, uf_this, fields) => {
				const args = { values, valids, uf_this };
				return (
					<>
						<UniFieldSUI data-testid="general_consent" fl={fields.general_consent} {...args} />
						<UniFieldSUI data-testid="treatment_consent" fl={fields.treatment_consent} {...args} />
						<UniFieldSUI data-testid="photo_consent" fl={fields.photo_consent} {...args} />
						<UniFieldSUI data-testid="financial_consent" fl={fields.financial_consent} {...args} />
						<UniFieldSUI data-testid="cost_consent" fl={fields.cost_consent} {...args} />
					</>
				);
			}}
		</UniFormMed>
	);
};
export default ConsentQuestions;
